import { render, staticRenderFns } from "./row-queue-management.vue?vue&type=template&id=71054a80&"
import script from "./row-queue-management.vue?vue&type=script&lang=js&"
export * from "./row-queue-management.vue?vue&type=script&lang=js&"
import style0 from "./row-queue-management.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports